/**
 * Navigation assistant review page.
 * Exposes the existing assistant drawer through routing so logged-in reviewers
 * can approve the experience before it becomes part of the shared header UI.
 * @module NavigationAssistantReview
 */

import React, { useCallback, useEffect, useState } from 'react';
import { Button } from 'antd';
import { CompassOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import PagesWrapper from '../../PagesWrapper';
import NavigationAssistant from '../../components/NavigationAssistant';
import styles from './NavigationAssistantReview.module.css';

/**
 * Hosts the navigation assistant drawer in a review-only page.
 * @returns {JSX.Element} Approval page for the navigation assistant.
 */
const NavigationAssistantReview = () => {
  const { t } = useTranslation();
  const [assistantOpen, setAssistantOpen] = useState(false);

  useEffect(() => {
    setAssistantOpen(true);
  }, []);

  const handleOpenAssistant = useCallback(() => {
    setAssistantOpen(true);
  }, []);

  const handleCloseAssistant = useCallback(() => {
    setAssistantOpen(false);
  }, []);

  return (
    <PagesWrapper>
      <section className={styles.heroSection}>
        <Button
            type="primary"
            size="large"
            icon={<CompassOutlined />}
            onClick={handleOpenAssistant}
            className={styles.openButton}
          >
            {t('assistant.openButton')}
        </Button>       
      </section>

      <NavigationAssistant open={assistantOpen} onClose={handleCloseAssistant} />
    </PagesWrapper>
  );
};

export default NavigationAssistantReview;